import { get } from 'lodash'
import moment from 'moment'

import { checkIsDataUpdated } from '../../../../Pages/Logs/logHelper'
import { primary_color } from '../../../../Helper/uiHelper'

export const LOCKER_EDIT_LOG_FIELDS = [
  { field_id: 'academic_year', label: 'Academic Year' },
  { field_id: 'year_group', label: 'Year Group' },
  { field_id: 'block', label: 'Block' },
  { field_id: 'locker_number', label: 'Locker Number' },
  { field_id: 'locker_added_to_maintenance', label: 'Locker added to maintenance' },
  { field_id: 'first_name', label: 'First Name' },
  { field_id: 'surname', label: 'Surname' },
  { field_id: 'payment_amount', label: 'Payment amount' },
  { field_id: 'payment_link_sent', label: 'Payment link sent' },
]

export const asLogRows = (data) => {
  if (!data) return []
  return Array.isArray(data) ? data.filter(Boolean) : [data]
}

export const normalizeLockerEditRow = (row = {}) => {
  const answers = row.questions_and_answers || {}
  return {
    ...row,
    academic_year: row.academic_year || row.item_date_time_id_label || '',
    year_group: row.year_group || row.category_id_label || '',
    block: row.block || row.location_id_label || '',
    locker_number: String(row.locker_number || row.item_id_label || ''),
    locker_added_to_maintenance: row.locker_added_to_maintenance || 'no',
    first_name: row.first_name || row.student_name || answers.student_name || '',
    surname: row.surname || row.student_surname || answers.student_surname || '',
    payment_amount: row.payment_amount || '',
    payment_link_sent: row.payment_link_sent || 'no',
  }
}

export const fillLockerLogRowFromOriginal = (updatedRow = {}, originalRow = {}) => {
  const updated = normalizeLockerEditRow(updatedRow)
  const original = normalizeLockerEditRow(originalRow)
  const moved = original.locker_number && updated.locker_number && original.locker_number !== updated.locker_number
  return {
    ...updated,
    first_name: updated.first_name || original.first_name,
    surname: updated.surname || original.surname,
    academic_year: updated.academic_year || original.academic_year,
    year_group: updated.year_group || original.year_group,
    block: updated.block || original.block,
    // Maintenance is the previous locker on a move, not the destination.
    locker_added_to_maintenance: moved ? 'no' : updated.locker_added_to_maintenance,
  }
}

export const isLockerEditLog = (rows) => asLogRows(rows).some((row) => row?.log_action === 'edit_locker')

export const lockerEditHeadline = (rows) => {
  const first = normalizeLockerEditRow(asLogRows(rows)[0] || {})
  const locker = first.locker_number || ''
  const block = first.block || ''
  if (!locker && !block) {
    return ' has edited the locker'
  }
  if (!block) {
    return ` has edited locker ${locker}`
  }
  return ` has edited locker ${locker} in ${block}`
}

export const lockerMoveHeadline = (originalRows, updatedRows) => {
  const from = normalizeLockerEditRow(asLogRows(originalRows)[0] || {}).locker_number
  const to = normalizeLockerEditRow(asLogRows(updatedRows)[0] || {}).locker_number
  if (from && to && from !== to) {
    return ` has moved the booking from locker ${from} to locker ${to}`
  }
  return ' has moved the booking'
}

export const LockerLogDifference = ({ data, original_data, updated_data, onExpand, headline }) => {
  const updatedRows = asLogRows(updated_data)
  const originalRows = asLogRows(original_data)
  const rows = updatedRows.length ? updatedRows : originalRows

  return (
    <div>
      <div className='permission-table'>
        <div className='mb-2 cursor-pointer' onClick={() => onExpand()}>
          <i className='fa-sharp fa-solid fa-arrow-left  m-3'></i>
          Go Back
        </div>
        <div className='permission-header' style={{ color: primary_color }}>
          <div className='d-flex align-items-center'>
            <div style={{ flex: 1 }}>
              <span className='font-weight-bold'>{data?.updated_by}</span>
              {headline}
            </div>
            {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
          </div>
        </div>
        <div className='p-4'>
          {rows.map((row, index) => {
            const originalRow = normalizeLockerEditRow(originalRows[index] || originalRows[0] || {})
            const displayRow = fillLockerLogRowFromOriginal(row, originalRow)
            return (
              <div key={displayRow?.locker_number || index}>
                <div className='d-flex mb-2 align-items-center' style={{ width: '100%' }}>
                  <div style={{ width: '40%' }}></div>
                  <div className='font-weight-bold' style={{ width: '30%' }}>
                    Now
                  </div>
                  <div className='font-weight-bold' style={{ width: '30%' }}>
                    Was
                  </div>
                </div>
                {LOCKER_EDIT_LOG_FIELDS.map((item) => {
                  const nowValue = get(displayRow, item.field_id)
                  const wasValue =
                    item.field_id === 'locker_added_to_maintenance' &&
                    originalRow.locker_number &&
                    displayRow.locker_number &&
                    originalRow.locker_number !== displayRow.locker_number
                      ? originalRow.locker_added_to_maintenance
                      : get(originalRow, item.field_id)
                  const changed = checkIsDataUpdated({ [item.field_id]: wasValue }, { [item.field_id]: nowValue }, item.field_id)
                  return (
                    <div className='d-flex mb-2 align-items-center' style={{ width: '100%' }} key={item.field_id}>
                      <div className='font-weight-bold mb-2' style={{ width: '40%' }}>
                        {item.label}:
                      </div>
                      <div style={{ width: '30%' }}>{nowValue}</div>
                      <div style={{ width: '30%' }} className={changed && wasValue ? 'p-2 bg-danger text-light' : ''}>
                        {wasValue}
                      </div>
                    </div>
                  )
                })}
                <hr></hr>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
